import React from 'react';
import styled from 'styled-components';
import { Text14Medium, TextInfo12 } from '../../../mixins/mixins';
import type { IButtonFeedBack } from './types';

const Button = styled.div`
  display: flex;
  width: 180px;
  height: 32px;
  border-radius: 32px;
  background: rgba(88, 255, 126, 1);
  color: black;
  ${Text14Medium};
  justify-content: center;
  align-items: center;
  cursor: pointer;
  :hover {
    cursor: pointer;
    background: white;
  }
  @media (max-width: 669px) {
    width: 130px;
    ${TextInfo12};
  }
`;

const ButtonFeedBack: React.FC<IButtonFeedBack> = ({ setIsVisible }) => (
    <Button onClick={() => setIsVisible(true)}>Contact us</Button>
);

export default ButtonFeedBack;
